import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import ViewModel from '../viewmodel/index';
import template from '../template/index.pug';
import { getHeaderDesc } from '../config/index';

function getSelectedIds() {
  return _.map(this.viewModel.selected(), opportunity => opportunity.id);
}

function triggerEvent(event) {
  this.trigger(event, getSelectedIds.call(this));
}

function back() {
  triggerEvent.call(this, 'back');
}

function apply() {
  triggerEvent.call(this, 'apply');
}

function dismiss() {
  triggerEvent.call(this, 'dismiss');
}

const biDataNames = ['conversion', 'costPerConversion', 'cost'];

export default class BidAdjustmentOptView extends Backbone.View {
  /**
   * @param {string} type - which type of your bid adjustment opt. e.g. location, scheduling
   * @param {Object} i18n - i18n object.
   * @param {Boolean} showBackBtn - display the Back button or not.
   * @param {Object[]} details - same as param of
   *   {@link BidAdjustmentOptView#setRaiseOrLowerDetails}
   * @param {Object} campaignBIData - same as param of
   *   {@link BidAdjustmentOptView#setRaiseOrLowerDetails}
   * @return {void} void
   */
  initialize({
    type,
    i18n,
    showBackBtn = false,
    details,
    campaignBIData,
  }) {
    this.type = type;
    this.i18n = i18n;
    this.showBackBtn = showBackBtn;
    this.viewModel = new ViewModel({
      type,
      i18n,
      details,
      campaignBIData,
    });
  }

  get events() {
    return {
      'click .back': back,
      'click .apply': apply,
      'click .dismiss': dismiss,
    };
  }

  render() {
    const model = _.extend({
      i18n: this.i18n,
      showBackBtn: this.showBackBtn,
      biDataNames,
      raiseHeader: '',
      raiseSubtitle: '',
      lowerHeader: '',
      lowerSubtitle: '',
      biDataDescriptions: {
        conversion: this.i18n.getString('BidAdjustmentOpt_Conversion'),
        costPerConversion: this.i18n.getString('BidAdjustmentOpt_CostPerConversion'),
        cost: this.i18n.getString('BidAdjustmentOpt_Cost'),
      },
    }, getHeaderDesc(this.type, this.i18n));

    this.$el.html(template(model));
    ko.applyBindings(this.viewModel, this.el);
    return this;
  }

  /**
   * set a list of raise/lower bid adjstument details object to the view,
   *   causing the view to render data.
   * @param {Object[]} details - a list of detail object
   * @param {string} details[].id - opportunity id
   * @param {number} details[].cost - cost
   * @param {number} details[].costDelta - cost delta
   * @param {number} details[].conversion - conversion
   * @param {number} details[].conversionDelta - conversion delta
   * @param {number} details[].bidMultiplier - bid adjustment multiplier,
   *   could be positive or negative number. Negative value means lower bid adjustment.
   * @param {string[]} details[].locationNames - only for location type.
       a list of strings representing the locations.
   * @param {number} details[].geoLevelId - only for location type. geo-location level id (integer),
   *   could be 0 (country), 1 (state), 2 (metro area), 3 (city), 4 (postal code).
   * Values greater than 4 does not have location level name.
   * @param {string} details[].dateAndTime - only for scheduling type. date and time
   * @param {Object} campaignBIData - overview KPI object
   * @param {number} campaignBIData.cost - cost of the current campaign
   * @param {number} campaignBIData.conversion - conversions of the current campaign
   * @returns {BidAdjustmentOptView} - return this for chanining purposes.
   */
  setRaiseOrLowerDetails(details, campaignBIData) {
    this.viewModel.setRaiseOrLowerDetails(details, campaignBIData);
    return this;
  }
}
